import { Amount, MonetaryAmount, PricePointAttributes } from 'api-client'
import DineroFactory, {
  Currency as DineroCurrency,
  Dinero,
  Options,
} from 'dinero.js'

export type Currency = DineroCurrency

export class Price {
  private dinero: Dinero

  constructor(options: Options | undefined = undefined) {
    this.dinero = DineroFactory(options)
  }

  static fromDinero = (dinero: Dinero) => {
    const price = new Price()
    price.dinero = dinero
    return price
  }

  static fromMonetaryAmount = (monetaryAmount: MonetaryAmount | undefined) =>
    monetaryAmount &&
    Price.fromDinero(
      DineroFactory({
        amount: Math.round(monetaryAmount.amount * 100),
        currency: monetaryAmount.currency as Currency,
        precision: 2,
      }),
    )

  add = (addend: Price) => Price.fromDinero(this.dinero.add(addend.dinero))

  subtract = (toSubtract: Price) =>
    Price.fromDinero(this.dinero.subtract(toSubtract.dinero))

  getCurrency = () => this.dinero.getCurrency()

  toFormat = (format?: string) => this.dinero.toFormat(format)

  toMonetaryAmount = (): MonetaryAmount => ({
    amount: this.dinero.getAmount() / Math.pow(10, this.dinero.getPrecision()),
    currency: this.dinero.getCurrency(),
  })

  toObject = () => ({
    amount: this.dinero.getAmount(),
    currency: this.dinero.getCurrency(),
    precision: this.dinero.getPrecision(),
  })
}

export interface PriceTier {
  price: Price | undefined
  quantity: Amount
}

export const pricePointAttributesToPriceTier = (
  pricePointAttributes: PricePointAttributes,
): PriceTier => {
  const price = Price.fromMonetaryAmount(pricePointAttributes.price)
  return {
    price,
    quantity: pricePointAttributes.pricingUnit,
  }
}
